import type { HTMLProps } from 'react';

import { getSourceMedia } from './get-source-media';

import type { Image, ImageWithDevices } from 'domains/content.d';

export function getSourceFromImageContent(
  image: ImageWithDevices
): Array<HTMLProps<HTMLSourceElement>> {
  const { desktop, mobile, tablet, ...defaultImage } = image;
  const imageSet = [desktop, mobile, tablet, defaultImage].filter((item) => !!item) as Image[];

  return imageSet.map((device) => {
    const media = getSourceMedia(device);

    return {
      srcSet: device.url ?? '',
      media,
    };
  });
}
